import makeStyles from "@mui/styles/makeStyles";

/**
 * Shared styling for the dashboard filter toolbar (segmented date presets on
 * the left, search + actions on the right, custom date range below). Used by
 * the Reusable RTP, RTP and User dashboards to keep their filters identical.
 */
export const filterToolbarStyles = makeStyles((theme) => ({
  toolbar: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    padding: theme.spacing(2.5),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.common.white,
    boxShadow: "0 1px 2px rgba(0, 32, 92, 0.06)",
    border: "1px solid rgba(0, 32, 92, 0.06)",
    marginBottom: theme.spacing(3),
  },
  topRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    alignItems: "center",
    justifyContent: "space-between",
  },
  customRange: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
    alignItems: "center",
  },
  searchGroup: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flexGrow: 1,
    justifyContent: "flex-end",
  },
  segment: {
    display: "inline-flex",
    padding: 3,
    borderRadius: 999,
    backgroundColor: "#EEF1F6",
    gap: 2,
  },
  segmentButton: {
    border: "none",
    cursor: "pointer",
    borderRadius: 999,
    padding: "7px 16px",
    fontSize: 13,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    backgroundColor: "transparent",
    transition: "all 120ms ease",
    "&:focus-visible": {
      outline: `2px solid ${theme.palette.secondary.main}`,
      outlineOffset: 2,
    },
  },
  segmentButtonActive: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
    boxShadow: "0 1px 3px rgba(0, 32, 92, 0.18)",
  },
  search: {
    minWidth: 320,
    flexGrow: 1,
    maxWidth: 460,
    "& .MuiOutlinedInput-root": {
      borderRadius: 999,
      backgroundColor: "#F7F8FA",
    },
  },
}));
